import { buildVersion } from "./buildInfo";

//This event will run on main page load and thank you page load
export function pageViewEvent(pageType) {
  window.adobeDataLayer = window.adobeDataLayer || [];
  let adobeDataLayerObj = {
    event: "pageView",
    web: {
      webPageDetails: {
        pageViews: {
          value: 1,
        },
        name: `icicibank:in:en:campaign:cards:creditcards:topcompanies:onboarding:${pageType}`,
        URL: window.location.href,
        isErrorPage: false,
      },
    },
    _icicibank: {
      channelInfo: {
        version: buildVersion,
        name: "nli",
      },
      pageInfo: {
        language: "en",
        country: "in",
        pageType: "campaign",
        virtualPageView: "no vpv",
        journey: "na",
        subJourney: "na",
        subSubJourney: "na",
      },
      userInfo: {
        userType: "na",
      },
      errorInfo: {
        errorType: "na",
        errorDetails: "na",
      },
    },
  };
  window.adobeDataLayer.push(adobeDataLayerObj);
}

//This function will be used for Click on Apply Now Button, FAQs, HomeLoanTypes, Benefits Button, T&Cs, Modal Close buttons and Alerts
export function ctaClickEvent(ctaName, ctaRegion, ctaType, faqClick, ctaUrl) {
  let adobeDataLayerObj = {
    event: "ctaClick",
    web: {
      webInteraction: {
        linkClicks: {
          value: 1,
        },
        name: "cta",
        URL: window.location.href,
        type: "other",
      },
    },
    _icicibank: {
      channelInfo: {
        version: buildVersion,
        name: "nli",
      },
      dateTime: {
        timeParting: getTimeParting(),
        unixTimestamp: Date.now(),
      },
      ctaInfo: {
        ctaName: ctaName,
        ctaRegion: ctaRegion,
        ctaType: ctaType,
        ctaURL: ctaUrl,
        faqClicks: faqClick,
      },
      pageInfo: {
        language: "en",
        pageType: "campaign",
        virtualPageView: "no vpv",
        journey: "na",
        subJourney: "na",
        subSubJourney: "na",
      },
      productInfo: {
        productName: "topcompany credit card",
        productCategory: "credit cards",
        productSubCategory: "all credit cards",
      },
    },
  };
  window.adobeDataLayer.push(adobeDataLayerObj);
}

//This function will be used when the main form starts or the calculator starts
export async function formStartEvent(formName, formType, formStepName) {
  await delay(300);
  let adobeDataLayerObj = {
    event: "formStarts",
    web: {
      webInteraction: {
        linkClicks: {
          value: 1,
        },
        name: "Form Start",
        URL: window.location.href,
        type: "other",
      },
    },
    _icicibank: {
      channelInfo: {
        version: buildVersion,
        name: "nli",
      },
      formInfo: {
        formName: formName,
        formType: formType,
        formStepName: formStepName,
      },
      pageInfo: {
        language: "en",
        pageType: "campaign",
        virtualPageView: "no vpv",
        journey: "na",
        subJourney: "na",
        subSubJourney: "na",
      },
      productInfo: {
        productName: "topcompany credit card",
        productCategory: "credit cards",
        productSubCategory: "all credit cards",
      },
    },
  };
  window.adobeDataLayer.push(adobeDataLayerObj);
}

//This function will be used for Successful Submission of Main Form and Calculator form
export async function formSuccessEvent(
  formName,
  formFields,
  formType,
  formStepName,
  otpAuthentication,
) {
  await delay(300);
  let formfieldString;
  if (formFields) {
    let elements = [];
    for (let key in formFields) {
      elements.push(`${key}:${formFields[key]}`);
    }
    formfieldString = elements.join("|");
  }
  let adobeDataLayerObj = {
    event: "formSuccess",
    web: {
      webInteraction: {
        linkClicks: {
          value: 1,
        },
        name: "Form Submit",
        URL: window.location.href,
        type: "other",
      },
    },
    _icicibank: {
      formInfo: {
        formName: formName,
        formFields: formfieldString,
        formType: formType,
        formStepName: formStepName,
        bankNameDetail: "na",
      },
      channelInfo: {
        version: buildVersion,
        name: "nli",
      },
      pageInfo: {
        language: "en",
        pageType: "campaign",
        virtualPageView: "no vpv",
        journey: "na",
        subJourney: "na",
        subSubJourney: "na",
      },
      userInfo: {
        accountType: "na",
        userType: "na",
      },
      productInfo: {
        productName: "topcompany credit card",
        productCategory: "credit cards",
        productSubCategory: "all credit cards",
      },
    },
  };
  if (otpAuthentication) {
    adobeDataLayerObj._icicibank.authenticationInfo = {
      otpAuthentication: 1,
    };
  }
  window.adobeDataLayer.push(adobeDataLayerObj);
}

//This function will be used for when OTP is received/verified as part of Intermediate Form Tracking
export function formIntermediateEvent(otpStatus, formField) {
  let adobeDataLayerObj = {
    event: "formIntermediate",
    web: {
      webInteraction: {
        linkClicks: {
          value: 1,
        },
        name: "Form Intermediate",
        URL: window.location.href,
        type: "other",
      },
    },
    _icicibank: {
      formInfo: {
        formName: "topcompany lead form",
        formFields: formField,
        formType: "lead generation",
        formStepName: `${otpStatus} otp`,
        bankNameDetail: "na",
      },
      pageInfo: {
        language: "en",
        pageType: "campaign",
        virtualPageView: "no vpv",
        journey: "na",
        subJourney: "na",
        subSubJourney: "na",
      },
      userInfo: {
        accountType: "na",
      },
      authenticationInfo: {
        otpAuthentication: 1,
      },
      productInfo: {
        productName: "topcompany credit card",
        productCategory: "credit cards",
        productSubCategory: "all credit cards",
      },
    },
  };
  window.adobeDataLayer.push(adobeDataLayerObj);
}

//This function will be used when there are errors in form fields
export function formFieldErrorEvent(errorFields) {
  let errorFieldString;
  let formFieldString;
  if (errorFields) {
    let errorElements = [];
    let fieldElements = [];
    for (let key in errorFields) {
      errorElements.push(`${key}:${errorFields[key]}`);
      fieldElements.push(key);
    }
    errorFieldString = errorElements.join("|");
    formFieldString = fieldElements.join("|");
  }
  let adobeDataLayerObj = {
    event: "formFieldError",
    web: {
      webInteraction: {
        linkClicks: {
          value: 1,
        },
        name: "Form Field Error",
        URL: window.location.href,
        type: "other",
      },
    },
    _icicibank: {
      formInfo: {
        formName: "topcompany lead form",
        formFields: formFieldString,
        formType: "lead generation",
        formStepName: "details",
      },
      channelInfo: {
        version: buildVersion,
        name: "nli",
      },
      pageInfo: {
        language: "en",
        pageType: "campaign",
        virtualPageView: "no vpv",
        journey: "na",
        subJourney: "na",
        subSubJourney: "na",
      },
      productInfo: {
        productName: "topcompany credit card",
        productCategory: "credit cards",
        productSubCategory: "all credit cards",
      },
      errorInfo: {
        errorType: "Form Field Errors",
        errorDetails: errorFieldString,
      },
    },
  };
  window.adobeDataLayer.push(adobeDataLayerObj);
}

//This function will be used when the form submission fails
export function formSubmissionFailEvent() {
  let adobeDataLayerObj = {
    event: "formSubmissionFail",
    web: {
      webInteraction: {
        linkClicks: {
          value: 1,
        },
        name: "Form Submission Fail",
        URL: window.location.href,
        type: "other",
      },
    },
    _icicibank: {
      formInfo: {
        formName: "topcompany lead form",
        formType: "lead generation",
      },
      channelInfo: {
        version: buildVersion,
        name: "nli",
      },
      pageInfo: {
        language: "en",
        pageType: "campaign",
        virtualPageView: "no vpv",
        journey: "na",
        subJourney: "na",
        subSubJourney: "na",
      },
      productInfo: {
        productName: "topcompany credit card",
        productCategory: "credit cards",
        productSubCategory: "all credit cards",
      },
      errorInfo: {
        errorType: "Form Submission Fail",
        errorDetails: "otp:exceeded attempts or other",
      },
    },
  };
  window.adobeDataLayer.push(adobeDataLayerObj);
}

//This function will be used for Main Form Abandonment and Calculator Form Abandonment
export function formAbandonmentEvent(
  formName,
  formType,
  lastAccessedField,
  formStepName,
) {
  //await delay(300);
  let adobeDataLayerObj = {
    event: "formAbandonment",
    web: {
      webInteraction: {
        linkClicks: {
          value: 1,
        },
        name: "Form abandonment",
        URL: window.location.href,
        type: "other",
      },
    },
    _icicibank: {
      formInfo: {
        formName: formName,
        formFields: "na",
        formType: formType,
        bankNameDetail: "na",
        formStepName: formStepName,
        lastAccessedField: lastAccessedField,
      },
      channelInfo: {
        version: buildVersion,
        name: "nli",
      },
      pageInfo: {
        language: "en",
        pageType: "campaign",
        virtualPageView: "no vpv",
        journey: "na",
        subJourney: "na",
        subSubJourney: "na",
      },
      userInfo: {
        accountType: "na",
        userType: "na",
      },
      productInfo: {
        productName: "topcompany credit card",
        productCategory: "credit cards",
        productSubCategory: "all credit cards",
      },
    },
  };
  window.adobeDataLayer.push(adobeDataLayerObj);
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function getTimeParting() {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const now = new Date();
  const year = now.getFullYear();
  const month = months[now.getMonth()];
  const date = now.getDate();
  const day = days[now.getDay()];
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const time = `${formattedHours}:${minutes < 10 ? "0" + minutes : minutes} ${ampm}`;

  const timeParting = `year=${year} | month=${month} | date=${date} | day=${day} | time=${time}`;

  return timeParting;
}
